import { InjectableClass } from '@fino/lib-injection';
import { TicketTableStatusFilter } from './ticketOverview.constants';
import {
  TicketStatesSiblings,
  TicketStates,
} from '../../ticket/ticket.constants';
import _ from 'lodash';

export class TicketFilterService extends InjectableClass {
  constructor($log) {
    'ngInject';
    super({ $log });
    // The filter types which can be selected via dropdown
    this.filterTypes = {
      states: 'ticket.list.overview.states',
      dates: 'ticket.list.overview.dates',
    };
  }

  get showClosed() {
    if (!this.headerOptions.ticketList) return false;
    return this.headerOptions.ticketList.filter.closed;
  }

  // Sets filter type
  setFilterType(filterType) {
    this.currentFilterType = filterType;
    this.headerOptions = {};
    this.ticketStatusFilter = {};
  }

  setFilterables(ticketList) {
    this.ticketStatusList = ticketList;
  }

  isStatusFiltered(status, explicit = false) {
    if (explicit) {
      return this.isExplicitFilter(this.ticketStatusFilter[status]);
    }
    return !!this.ticketStatusFilter[status];
  }

  toggleFilter(status, options = {}) {
    const { explicit } = options;
    const statusFiltered = this.isStatusFiltered(status, explicit);

    // Check if we include or exclude the given status
    this.$log.debug('toggleFilter', { status, options, statusFiltered });

    this.setStatusFilter(status, !statusFiltered, explicit);

    // Apply actual ticket status filter to the headerOptions
    // NOTE: Any change to the headerOptions will trigger a
    // filterTable call in the ticketList controller to update
    // the ticket table representation.
    //    this.$scope.$broadcast('refreshTable', options);

    this.headerOptions.filterStatus = angular.copy(this.ticketStatusFilter);
    return this.headerOptions;
  }

  setStatusFilter(status, statusFiltered, explicit = false) {
    this.$log.debug('setStatusFilter', { status, statusFiltered, explicit });

    // Handle explicit status filtering separately
    if (explicit) {
      this.setStatusFilterExplicit(status, statusFiltered);
      return;
    }

    // Any other filtering will reset an explicit filtering
    this.resetStatusFilterExplicit();

    if (statusFiltered) {
      this.ticketStatusFilter[status] = statusFiltered;
    } else {
      delete this.ticketStatusFilter[status];
    }

    // Apply status to all ticket status siblings
    if (TicketStatesSiblings[status]) {
      TicketStatesSiblings[status].map((sibling) => {
        if (statusFiltered) {
          this.ticketStatusFilter[sibling] = statusFiltered;
        } else {
          delete this.ticketStatusFilter[sibling];
        }
      });
    }
  }

  setStatusFilterExplicit(status, statusFiltered) {
    // If status is explicit, we reset the actual ticket status filtering.
    this.resetStatusFilter();

    // Check for not filtered (reversed logic for explicit filtering)
    if (!statusFiltered) {
      this.resetStatusFilterExplicit();
      return;
    }

    // To filter the given status explicitly we have to
    // swap the filter logic by excluding all available
    // status and only include the given status.
    _.each(this.ticketStatusList, (count, ticketStatus) => {
      if (ticketStatus !== status) {
        this.setStatusFilter(ticketStatus, true);
      }
    });

    this.setStatusFilter(status, { explicit: true });
  }

  resetStatusFilter() {
    this.ticketStatusFilter = {};
  }

  resetStatusFilterExplicit() {
    _.each(this.ticketStatusFilter, (filtered, status) => {
      if (this.isExplicitFilter(filtered)) {
        delete this.ticketStatusFilter[status];
      }
    });
  }

  getAllFilters() {
    const { ticketsType } = this;
    return _.merge(
      {},
      TicketTableStatusFilter[ticketsType].active,
      TicketTableStatusFilter[ticketsType].closed,
    );
  }

  getFilterType(defaultType = 'active') {
    return _.get(this.headerOptions, 'ticketList.label', defaultType);
  }

  getValidStatesForFilterType() {
    const { ticketsType } = this;
    const filterType = this.getFilterType();
    return TicketTableStatusFilter[ticketsType][filterType];
  }

  // Handles changing filter type in frontend
  handleChangeFilterType({ tabId }) {
    this.setFilterType(tabId);
  }

  // Handles changing filter in frontend
  handleUpdateFilter({ filter }, options) {
    this.toggleFilter(filter, options);
  }

  isExplicitFilter(filter) {
    return angular.isObject(filter) && filter.explicit;
  }

  headerInput(options) {
    let statusSearchInputs = _.filter(
      options.searchInputs,
      (si) => si.type === 'status',
    );

    _.each(statusSearchInputs.slice(), (si) => {
      if (TicketStatesSiblings[si.key]) {
        statusSearchInputs = statusSearchInputs.concat(
          _.map(TicketStatesSiblings[si.key], (key) => {
            return {
              key,
              type: 'status',
            };
          }),
        );
      }
    });

    this.ticketStatusFilter = {};
    if (statusSearchInputs.length) {
      // synchronise chart filter with search filter
      _.forEach(TicketStates, (ts) => {
        this.ticketStatusFilter[ts] = true;
      });
      _.forEach(statusSearchInputs, (ssi) => {
        this.ticketStatusFilter[ssi.key] = false;
      });
    }

    _.assign(this.headerOptions, options);
    this.headerOptions.filterStatus = angular.copy(this.ticketStatusFilter);
  }
}
